import * as THREE from 'three'
import HelvetikerFont from "three/examples/fonts/helvetiker_regular.typeface.json";

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import GUI from 'lil-gui'

/**
 * Raycaster
 */

const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();
const streamingServices = [];

/**
 * Base
 */
// Debug
// const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('textures/matcaps/8.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace
const albumArt = textureLoader.load('image/cover.jpg')
albumArt.colorSpace = THREE.SRGBColorSpace

/**
 * Fonts
 */
const fontLoader = new FontLoader()
const font = fontLoader.parse(HelvetikerFont);
const material = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
const coverArt = new THREE.MeshMatcapMaterial({ matcap: albumArt })
const textGeometry = new TextGeometry(
    'Sure, Why Not?\n     out now!', 
    {
        font: font,
        size: 0.5,
        depth: 0.2,
        height: 0.2,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 5,
    }
);
textGeometry.center()

const text = new THREE.Mesh(textGeometry, material);
text.position.y = 0
scene.add(text);

/**
 * Streaming Sites
 */

const sites = [
    { text: 'Spotify', url: 'https://open.spotify.com/artist/1qlBN8JibUfhwVcJ3iI7WE?si=m5Z-_5k3QuCV2XJtEAVpJQ'},
    { text: 'Bandcamp', url: 'https://atomiclights.bandcamp.com/merch'},
    { text: 'Youtube', url: 'https://www.youtube.com/@AtomicLightsband'},
    { text: 'Apple Music', url: 'https://music.apple.com/us/artist/atomic-lights/1449082269'}
];
var middle = -2
sites.forEach(({ text, url }) => {

    const socialGeometry = new TextGeometry(text, {
        font: font,
        size: 0.5,
        depth: 0.2,
        height: 0.2,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 5,
    });

    socialGeometry.center()
    const social = new THREE.Mesh(socialGeometry, material);
    social.position.set(0, middle, 0)
    middle -= 1
    social.userData.url = url;
    scene.add(social)
    streamingServices.push(social);
});

scene.position.set(0, 2.5, 0)

// Squares
const planeGeometry = new THREE.PlaneGeometry(1.5, 1.5)

for(let i = 0; i < 150; i++)
{
    const cover = new THREE.Mesh(planeGeometry, coverArt)
    cover.position.x = (Math.random() - 0.5) * 20
    cover.position.y = (Math.random() - 0.5) * 20
    cover.position.z = (Math.random() - 0.5) * 20
    cover.rotation.x = Math.random() * Math.PI
    cover.rotation.y = Math.random() * Math.PI
    const scale = Math.random()
    cover.scale.set(scale, scale, scale)

    scene.add(cover)
}

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Raycaster part 2
 */
let pointerDownPos = null;

addEventListener('pointerdown', (event) => {
  pointerDownPos = { x: event.clientX, y: event.clientY };
});

addEventListener('pointerup', (event) => {
  if (!pointerDownPos) return;

  const dx = event.clientX - pointerDownPos.x;
  const dy = event.clientY - pointerDownPos.y;
  const distance = Math.sqrt(dx * dx + dy * dy);

  if (distance < 5) {
    // Considered a click
    const x = event.clientX;
    const y = event.clientY;

    mouse.x = (x / window.innerWidth) * 2 - 1;
    mouse.y = -(y / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(streamingServices);

    if (intersects.length > 0) {
      const mesh = intersects[0].object;
      const url = mesh.userData.url;

      // Mobile Safari prefers location.href to open in the same tab
      if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
        window.location.href = url;
      } else {
        window.open(url, '_blank', 'noopener');
      }
    }
  }

  pointerDownPos = null; // Reset after click
});

// window.addEventListener('click', onClick);
// window.addEventListener('touchend', onClick);


/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = -1
camera.position.z = 7
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Audio
 */
// const songListener = new THREE.AudioListener();
// camera.add( songListener );

// const song = new THREE.Audio( songListener );

// // load a sound and set it as the Audio object's buffer
// const audioLoader = new THREE.AudioLoader();
// audioLoader.load( 'song/01.I\'m Ok.wav', function( buffer ) {
// 	song.setBuffer( buffer );
// 	song.setLoop( true );
// 	song.setVolume( 0.5 );
// 	song.play();
// });

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update the text
    text.position.x = Math.cos(elapsedTime) * 1.5
    text.position.z = Math.sin(elapsedTime) * 1.5
    text.position.y = Math.sin(elapsedTime * 3)

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
